module.exports = __webpack_public_path__ + "static/media/education.6a4d6ac6.svg";